<template>
  <div id="April2024" class="202404 relative">
    <div class="fixed z-50 hidden xl:block" :class="{ 'fixed-btn': isMenu, 'hidden-btn': !isMenu}">
      <a class="block px-3">
        <img src="~@/assets/images/202404/menu/00-menu-bar-off_01.png" class="object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan1')">
        <img src="~@/assets/images/202404/menu/00-menu-bar-off_02.png" class="off object-contain">
        <img src="~@/assets/images/202404/menu/00-menu-bar-on_02.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan2')">
        <img src="~@/assets/images/202404/menu/00-menu-bar-off_03.png" class="off object-contain">
        <img src="~@/assets/images/202404/menu/00-menu-bar-on_03.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan3')">
        <img src="~@/assets/images/202404/menu/00-menu-bar-off_04.png" class="off object-contain">
        <img src="~@/assets/images/202404/menu/00-menu-bar-on_04.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan4')">
        <img src="~@/assets/images/202404/menu/00-menu-bar-off_05.png" class="off object-contain">
        <img src="~@/assets/images/202404/menu/00-menu-bar-on_05.png" class="on object-contain">
      </a>
    </div>

    <div class="banner w-full pt-10 md:pt-6 pb-24">
      <div class="container px-2">
        <div class="hidden md:block"><img src="~@/assets/images/202404/01-liveabc-LOGO.png" class="object-contain block"></div>
        <div><img src="~@/assets/images/202404/01-master_title.png" class="object-contain block mx-auto"></div>
        <div><img src="~@/assets/images/202404/01-pic-kids.png" class="object-contain block mx-auto"></div>
        <div class="mt-4">
          <img src="~@/assets/images/202404/01-memu-bar.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202404/01-memu-bar_m.png" class="object-contain block mx-auto md:hidden">
        </div>
      </div>
    </div>

    <section class="main mx-auto">
      <div id="plan1" class="plan1 px-2 py-6">
        <div><img src="~@/assets/images/202404/02-title-bar.png" class="object-contain block mx-auto -mt-24"></div>
        <div class="flex justify-center container flex-col md:flex-row">
          <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 7725 } }" class="p-3 order-3 md:order-1"><img src="~@/assets/images/202404/02-ABC-COVER.png" class="object-contain block w-1/2 md:w-auto mx-auto"></router-link>
          <div class="p-3"><img src="~@/assets/images/202404/02-txt-info.png" class="object-contain block"></div>
          <div class="mb-5 md:mb-0">
            <div class="mb-4 p-3 hidden md:block"><img src="~@/assets/images/202404/02-pic.png" class="object-contain block"></div>
            <a target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=355"><img src="~@/assets/images/202404/02-order-button.png" class="object-contain block mx-auto md:m-0"></a>
          </div>
        </div>
        <div class="flex flex-wrap container mb-4 justify-center md:justify-start">
          <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="p-3 w-1/2 md:flex-1" v-for="(item, index) in bookData" :key="index" :class="item.class" target="_blank">
            <img :src="item.img_url" class="object-contain block mx-auto"></router-link>
        </div>
        <a target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=355" class="w-full"><img src="~@/assets/images/202404/02-other-button.png" class="object-contain block mx-auto"></a>
      </div>
      <div id="plan2" class="plan2 px-2 py-16">
        <div class="flex container mx-auto justify-center">
          <div class="px-3  items-center hidden md:flex"><img src="~@/assets/images/202404/03-flower-line-L.png" class="object-contain block"></div>
          <div class="plan2_inner bg-white px-8 pb-4">
            <div class="mb-4"><img src="~@/assets/images/202404/03-title.png" class="object-contain block mx-auto -mt-12"></div>
            <div class="flex flex-col md:flex-row">
              <div>
                <div class="mb-8"><img src="~@/assets/images/202404/03-txt-info.png" class="object-contain block"></div>
                <div class="hidden md:flex items-center">
                  <a target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=356" class="mr-4 cursor-pointer"><img src="~@/assets/images/202404/03-more-button.png" class="object-contain block"></a>
                  <a target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=356" class="cursor-pointer"><img src="~@/assets/images/202404/add_btn.png" class="object-contain block"></a>
                </div>
              </div>
              <div class="relative">
                <div><img src="~@/assets/images/202404/03-pic-livepen.png" class="object-contain block"></div>
                <div class="absolute best-img"><img src="~@/assets/images/202404/03-title-babo.png" class="object-contain block"></div>
              </div>

              <div class="flex items-center justify-center md:hidden mt-4">
                <a target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=356" class="cursor-pointer"><img src="~@/assets/images/202404/add_btn.png" class="object-contain block"></a>
              </div>
            </div>
          </div>
          <div class="px-3 items-center hidden md:flex"><img src="~@/assets/images/202404/03-flower-line-L.png" class="object-contain block"></div>
        </div>
      </div>
      <div id="plan3" class="plan3 px-2 py-16 pt-40 md:pt-16">
        <div class="plan3_inner max-w-6xl mx-auto">
          <div class="-mt-20 justify-center hidden md:flex">
            <div class=""><img src="~@/assets/images/202404/04-pic-L.png" class="object-contain block"></div>
            <div class="">
              <div class="mb-8"><img src="~@/assets/images/202404/04-title.png" class="object-contain block"></div>
              <p class="text-white text-center leading-loose text-lg">此活動專區必須選擇3個商品或是3的倍數購買<br/>例如3本、6本、9本..以此類推，滿足活動條件才享有活動優惠。</p>
            </div>
            <div class=""><img src="~@/assets/images/202404/04-pic-R.png" class="object-contain block"></div>
          </div>
          <div class="-mt-48 justify-center md:hidden px-4">
            <div class="flex justify-center -mb-6 px-6">
              <div class=""><img src="~@/assets/images/202404/04-pic-L.png" class="object-contain block"></div>
              <div class=""><img src="~@/assets/images/202404/04-pic-R.png" class="object-contain block"></div>
            </div>
            <div class="mb-4">
              <div class="mb-2"><img src="~@/assets/images/202404/04-title.png" class="object-contain block"></div>
              <p class="text-white text-center leading-loose md:text-lg">此活動專區必須選擇3個商品或是3的倍數購買<br/>例如3本、6本、9本..以此類推，滿足活動條件才享有活動優惠。</p>
            </div>
          </div>
          <div class="flex pr-4 md:pr-8 flex-wrap items-center md:items-start" v-for="(item, index) in bookData2" :key="index">
            <div class="writing-mode text-white md:p-2 md:text-xl">{{ item.title }}</div>
            <div class="flex-1 flex flex-wrap">
              <router-link :to="{ name: 'detail', params: { category: 'book', id: kid.id } }" class="w-1/2 md:w-1/4 item p-2" v-for="(kid, index) in item.items" :key="index" target="_blank">
                <div class="bg-white px-3 py-6 rounded-t-lg">
                  <div class="outer mb-2">
                    <div class="inner mx-auto border-0 absolute w-full h-full">
                      <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!kid.img_url">
                      <img v-lazy="kid.img_url" class="w-full h-full object-contain block" v-else>
                    </div>
                  </div>
                </div>
                <div class="item-title text-center rounded-b-lg p-3 py-4">
                  <p class="md:text-lg font-semibold">{{ kid.title }}</p>
                  <p class="text-xl font-semibold">原價<span class="text-red-600">{{ kid.price }}</span>元</p>
                </div>
              </router-link>
            </div>

          </div>
          <a target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=352" class="mt-12"><img src="~@/assets/images/202404/04-more-button.png" class="object-contain block mx-auto -mb-8"></a>
        </div>
      </div>
      <div id="plan4" class="plan4 px-2 pt-16 pb-3">
        <div class="plan4_inner max-w-6xl mx-auto px-2 md:px-8 pb-6">
          <div class="-mt-16 plan4-title hidden md:block">
            <div class="flex justify-center items-center">
              <div class="px-3"><img src="~@/assets/images/202404/05-pic-L.png" class="object-contain block"></div>
              <div class="px-3"><img src="~@/assets/images/202404/05-title.png" class="object-contain block"></div>
              <div class="px-3"><img src="~@/assets/images/202404/05-pic-R.png" class="object-contain block"></div>
            </div>
            <p class="text-center text-2xl leading-loose font-light">※本產品僅包含電腦互動軟體，不含紙本書</p>
            <p class="text-center text-lg leading-loose">1.總共可安裝於2台電腦，最多可下載安裝6次。2.可於Windows系統（語系：繁中/英）安裝使用，Mac系統不支援。<br/>3.適用於電腦、筆電，手機或平板不支援安裝使用。</p>
          </div>
          <div class="-mt-16 plan4-title md:hidden">
            <div class="flex justify-center items-center">
              <!-- <div class="px-3"><img src="~@/assets/images/202404/05-pic-L.png" class="object-contain block"></div> -->
              <div class=""><img src="~@/assets/images/202404/05-title.png" class="object-contain block"></div>
              <!-- <div class="px-3"><img src="~@/assets/images/202404/05-pic-R.png" class="object-contain block"></div> -->
            </div>
            <div class="flex justify-center items-center px-5">
              <div class="px-3"><img src="~@/assets/images/202404/05-pic-L.png" class="object-contain block"></div>
              <p class="text-center text-sm leading-loose font-light">※本產品僅包含電腦互動軟體，不含紙本書</p>
              <div class="px-3"><img src="~@/assets/images/202404/05-pic-R.png" class="object-contain block"></div>
            </div>
            <!-- <p class="text-center text-2xl leading-loose font-light">※本產品僅包含電腦互動軟體，不含紙本書</p> -->
            <p class="text-center font-semibold px-3">1.總共可安裝於2台電腦，最多可下載安裝6次。<br/>2.可於Windows系統（語系：繁中/英）安裝使用，Mac系統不支援。<br/>3.適用於電腦、筆電，手機或平板不支援安裝使用。</p>
          </div>
          <div class="flex flex-wrap">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="w-1/2 md:w-1/4 item p-2" v-for="(item, index) in bookData3" :key="index" target="_blank">
              <div class="bg-white px-3 py-3 rounded-t-lg">
                <!-- <img :src="item.img_url" class="object-contain block mx-auto"> -->
                <div class="outer mb-2">
                  <div class="inner mx-auto border-0 absolute w-full h-full">
                    <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!item.img_url">
                    <img v-lazy="item.img_url" class="w-full h-full object-contain block" v-else>
                  </div>
                </div>
                <p class="md:text-lg font-semibold text-center plan4-title">{{ item.quote }}</p>
              </div>
              <div class="item-title text-center rounded-b-lg py-2">
                <p class="text-sm mb-1 line-through">原價{{ item.price }}元</p>
                <p class="text-xl font-semibold">75折<span class="text-red-600">{{ item.new_price }}</span>元</p>
              </div>
            </router-link>
          </div>
          <a target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=357" class="mt-12"><img src="~@/assets/images/202404/05-more-button.png" class="object-contain block mx-auto -mb-12"></a>
        </div>
      </div>
    </section>

    <section class="footer py-10">
      <div class="container px-4 text-center font-semibold tracking-wider">
        <p class="text-lg">詳細活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</p>
      </div>
    </section>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'April2023',
  metaInfo () {
    return {
      title: '學習計畫從小啟動｜LiveABC兒童書展限時優惠',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: true,
      bookData: [
        // { id: 7694, img_url: require('@/assets/images/202404/02-ABC-COVER.png'), class: 'md:hidden' },
        { id: 7726, img_url: require('@/assets/images/202404/02-all-cover.png'), class: '' },
        { id: 7727, img_url: require('@/assets/images/202404/02-cnn-cover.png'), class: '' },
        { id: 7728, img_url: require('@/assets/images/202404/02-hiw-cover.png'), class: '' },
        { id: 7729, img_url: require('@/assets/images/202404/02-japne-cover.png'), class: '' },
        { id: 7724, img_url: require('@/assets/images/202404/02-live-cover.png'), class: '' }
      ],
      bookData2: [
        { title: '學齡前∣國小推薦',
          items: [
            { id: 7694, title: '認識26個字母、200個單字', price: 420, img_url: require('@/assets/images/202404/04/image 01.png') },
            { id: 7549, title: '動物園、遊樂園等場景', price: 420, img_url: require('@/assets/images/202404/04/image 02.png') },
            { id: 6935, title: '居家、校園等生活英語', price: 420, img_url: require('@/assets/images/202404/04/image 03.png') },
            { id: 8134, title: '國中小基本2000個單字', price: 499, img_url: require('@/assets/images/202404/04/image 04.png') }
          ]
        },
        { title: '中學生必備',
          items: [
            { id: 9108, title: '國中文法化繁為簡、歸納學習', price: 399, img_url: require('@/assets/images/202404/04/image 05.png') },
            { id: 8742, title: '自然發音+KK音標一起學', price: 450, img_url: require('@/assets/images/202404/04/image 06.jpg') },
            { id: 7582, title: '符合國中自然科學內容', price: 450, img_url: require('@/assets/images/202404/04/image 07.png') },
            { id: 8588, title: '符合108課綱 練習英語會話', price: 499, img_url: require('@/assets/images/202404/04/image 08.png') }
          ]
        },
        { title: '升學考試利器',
          items: [
            { id: 7873, title: 'GEPT考前衝刺必備工具書', price: 399, img_url: require('@/assets/images/202404/04/image 09.png') },
            { id: 7104, title: '刷題必備 增加實戰能力', price: 450, img_url: require('@/assets/images/202404/04/image 10.png') },
            { id: 8463, title: '會考/學測/英檢必考單字表列', price: 499, img_url: require('@/assets/images/202404/04/image 11.png') },
            { id: 7399, title: '一張圖能記住約15個單字', price: 450, img_url: require('@/assets/images/202404/04/image 12.png') }
          ]
        },
        { title: 'STEAM跨域學習',
          items: [
            { id: 8587, title: '五大主題一次掌握最新科技', price: 450, img_url: require('@/assets/images/202404/04/image 13.png') },
            { id: 8464, title: '用科學解釋你我的生活日常', price: 450, img_url: require('@/assets/images/202404/04/image 14.png') },
            { id: 8167, title: '了解自然萬物與生態環境', price: 450, img_url: require('@/assets/images/202404/04/image 15.png') },
            { id: 8151, title: '各種創新的代步工具', price: 450, img_url: require('@/assets/images/202404/04/image 16.png') }
          ]
        },
        { title: '出國留遊學必讀',
          items: [
            { id: 6378, title: '出國求學/移民/工作必備', price: 480, img_url: require('@/assets/images/202404/04/image 17.png') },
            { id: 6051, title: '打好基礎托福拿高分', price: 399, img_url: require('@/assets/images/202404/04/image 18.png') },
            { id: 8214, title: '從模仿學會各種道地用法', price: 450, img_url: require('@/assets/images/202404/04/image 19.png') },
            { id: 7849, title: '學會單字的運用及語意', price: 380, img_url: require('@/assets/images/202404/04/image 20.png') }
          ]
        }
      ],
      bookData3: [
        { id: 8934, quote: '深度暢遊必遊景點', img_url: require('@/assets/images/202404/05/image 001.png'), price: 224, new_price: 168 },
        { id: 8936, quote: '養成英語閱讀力', img_url: require('@/assets/images/202404/05/image 002.png'), price: 224, new_price: 168 },
        { id: 8744, quote: '一起打造旅遊英語力', img_url: require('@/assets/images/202404/05/image 003.png'), price: 220, new_price: 165 },
        { id: 8629, quote: '學英語最好的題材', img_url: require('@/assets/images/202404/05/image 004.png'), price: 220, new_price: 165 },
        { id: 8631, quote: '讓閱讀變成一種享受', img_url: require('@/assets/images/202404/05/image 005.png'), price: 165, new_price: 124 },
        { id: 8473, quote: '主題包羅萬象', img_url: require('@/assets/images/202404/05/image 006.png'), price: 220, new_price: 165 },
        { id: 7503, quote: '12大旅遊場景', img_url: require('@/assets/images/202404/05/image 007.png'), price: 193, new_price: 145 },
        { id: 7840, quote: '隨時用英語提出建議', img_url: require('@/assets/images/202404/05/image 008.png'), price: 193, new_price: 145 }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#April2024 {
  .toggle-btn {
    top: 20%;
    left: -50%;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    right: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    right: -174px;
    transition: 0.3s;
  }
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .outer {
    position: relative;
    width: 100%;
    display: block;
    &:after {
      content: "";
      display: block;
      padding-Bottom: 100%;
    }
    .inner {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .banner {
    background-image: url('~@/assets/images/202404/background.png');
    background-repeat: no-repeat;
    background-size: contain, cover;

    background-position: top center, center;
    @media (max-width: 768px) {
      background-image: url('~@/assets/images/202404/background_m.png');
    }
  }
  .main {
    .plan1 {
      background-image: url('~@/assets/images/202404/02-Pattern.png');
    }
    .plan2 {
      background-color: #d1e8f1;
      .plan2_inner {
        box-shadow: 10px 10px 0px 0px #00000040;
        border: 3px solid #0367A6;
        border-radius: 25px;
        background-image: url('~@/assets/images/202404/03-frame-board.png');
        background-size: contain;
        .best-img {
          right: -12%;
          top: -42%;
          @media (max-width: 768px) {
            left: -5%;
            top: -5%;
            width: 30%;
          }
        }
      }
    }
    .plan3 {
      background-color: #d1e8f1;
      .plan3_inner {
        background-color: #0367A6;
        border: 3px solid #FFFFFF;
        box-shadow: 10px 10px 0px 0px #00000040;
        border-radius: 25px;
        background-size: contain;
        .writing-mode {
          -webkit-writing-mode: vertical-lr;
          writing-mode: vertical-lr;
        }
        .item-title {
          background: #F2EDA2;
          color: #0367A6;
        }
      }
    }
    .plan4 {
      background-color: #d1e8f1;
      .plan4_inner {
        background: #F2F2F2;
        box-shadow: 10px 10px 0px 0px #00000040;
        border: 3px solid #0367A6;
        border-radius: 25px;
        .writing-mode {
          -webkit-writing-mode: vertical-lr;
          writing-mode: vertical-lr;
        }
        .plan4-title {
          color: #0367A6;
        }
        .item-title {
          background: #F2EDA2;
          color: #0367A6;
        }
      }
    }
    .plan5 {
      .plan5-title {
        color: #0367A6;
      }
    }
    // .plan3 {
    //   .plan1_inner {
    //     border-radius: 75px;
    //     border: 6px solid #CC4915;
    //     box-shadow: 20px 20px 0px 0px #CC491540;
    //     @media (max-width: 768px) {
    //       border: 3px solid #CC4915;
    //       border-top-left-radius: 0px 0px;
    //       border-top-right-radius: 0px 0px;
    //       border-bottom-right-radius: 50px 50px;
    //       border-bottom-right-radius: 50px 50px;
    //       box-shadow: 10px 10px 0px 0px #CC491540;
    //     }
    //   }
    // }
  }

  .footer {
    background-color: #d1e8f1;
    color: #0367A6;
  }
}
</style>
